import { Box, DNAButton, DNAChip, DNAText, Icon, Iffy, luxColors, useOrientationChange, util } from '@alucio/lux-ui';
import { StyleSheet } from 'react-native';
import DNABox from '@alucio/lux-ui/src/components/layout/DNABox/DNABox';
import React from 'react';
import { useVideoContext } from '@alucio/video';
// import { useLocalAudioToggle, useLocalVideoToggle, useVideoContext } from '@alucio/video';
// import { useVirtualRoom } from '../../../state/redux/selector/virtualRoom';
// import { AUDIO_SOURCE } from '../../../state/redux/slice/virtualRoom';
const styles = StyleSheet.create({
    icon: {
        width: 28,
        height: 28,
        color: 'rgba(255, 255, 255, 0.4)',
    },
    endCallIcon: {
        width: 28,
        height: 28,
    },
    endCallButton: {
        borderRadius: 16,
        width: 60,
        height: 64,
        paddingLeft: 12,
        paddingRight: 12,
    },
    endItemText: {
        marginTop: 12,
    },
    menuItemText: {
        color: 'rgba(255, 255, 255, 0.4)',
        textAlign: 'center',
        textAlignVertical: 'center',
    },
    toolbarContainer: {
        justifyContent: 'space-between',
        paddingLeft: 32,
        paddingRight: 32,
        paddingTop: 11,
        paddingBottom: 21,
        backgroundColor: luxColors.virtual.background,
    },
    menuOptionChip: {
        position: 'absolute',
        top: 0,
        right: 0,
        height: 16,
        fontSize: 11,
        justifyContent: 'center',
        alignItems: 'center',
    },
});
function MenuItem(props) {
    const { labels, icons, enabled, onPress } = props;
    const icon = enabled ? icons[0] : icons[1];
    const label = enabled ? labels[0] : labels[1];
    const orientation = useOrientationChange();
    return (React.createElement(DNAButton, { appearance: "ghost", size: "tiny", onPress: onPress },
        React.createElement(DNABox, { alignX: "center", alignY: "center", appearance: "col", style: orientation === 'PORTRAIT' ? { maxWidth: 40 } : null },
            React.createElement(Icon, { name: icon, style: util.mergeStyles(undefined, styles.icon) }),
            React.createElement(DNAText, { style: styles.menuItemText }, label),
            props.chip)));
}
function EndCall(props) {
    return (React.createElement(DNAButton, { status: "danger", style: styles.endCallButton, onPress: props.onEndCall },
        React.createElement(Box, null,
            React.createElement(Icon, { name: "phone-hangup", style: util.mergeStyles(undefined, styles.endCallIcon) }),
            React.createElement(DNAText, { status: "basic" }, "End"))));
}
export default function Toolbar(props) {
    // const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();
    // const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
    // const { selectedAudioMode } = useVirtualRoom();
    const orientation = useOrientationChange();
    const { toggleChatVis, unreadMsgCount } = useVideoContext();
    return (React.createElement(DNABox, { appearance: "row", alignX: "stretch", alignY: "start", style: orientation === 'LANDSCAPE'
            ? styles.toolbarContainer
            : [styles.toolbarContainer, { paddingLeft: 8, paddingRight: 8 }], spacing: "large" },
        React.createElement(DNABox, { alignY: "start", alignX: "start" },
            React.createElement(MenuItem, { enabled: true, labels: ['Participants'], icons: ['account-multiple', 'account-multiple'], onPress: props.onPersonListPress }),
            React.createElement(MenuItem, { labels: ['Chat'], enabled: true, icons: ['chat-processing'], onPress: toggleChatVis, chip: React.createElement(Iffy, { is: unreadMsgCount > 0 },
                    React.createElement(DNAChip, { style: styles.menuOptionChip, appearance: "tag", status: "danger" }, unreadMsgCount.toString())) })),
        React.createElement(DNABox, null,
            React.createElement(EndCall, { onEndCall: props.onEndPress }))));
}
//# sourceMappingURL=DNAToolbar.js.map